import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import { CustomStyleSheet } from '../../../utils/rn/tools';
import { FONT_WEIGHT_MEDIUM } from '../../../styles/rn';
var Styles = CustomStyleSheet({
  container: {
    padding: 10.5,
    // 气泡有多余的 border，需要减去
    borderRadius: 12,
    backgroundColor: '#fff'
  },
  parcelInfo: {
    flexDirection: 'row',
    alignItems: 'flex-start'
  },
  imageContainer: {
    overflow: 'hidden',
    width: 56,
    height: 56,
    borderRadius: 6
  },
  image: {
    width: 56,
    height: 56,
    borderRadius: 6
  },
  mainInfo: {
    flex: 1,
    marginLeft: 8
  },
  title: _objectSpread({
    fontSize: 14,
    lineHeight: 16,
    color: 'rgba(0, 0, 0, 0.87)'
  }, FONT_WEIGHT_MEDIUM),
  thTitle: {
    lineHeight: 20
  },
  trackingNumberContainer: {
    marginTop: 4,
    flexDirection: 'row',
    alignItems: 'center'
  },
  thTrackingNumberContainer: {
    marginTop: 0
  },
  trackingNumberText: {
    flex: -1,
    fontSize: 14,
    lineHeight: 16,
    color: 'rgba(0, 0, 0, 0.54)'
  },
  thTrackingNumberText: {
    lineHeight: 20
  },
  copyButton: {
    marginLeft: 2
  },
  status: {
    marginTop: 4,
    fontSize: 14,
    lineHeight: 16,
    color: '#EE4D2D'
  },
  thStatus: {
    marginTop: 0,
    lineHeight: 20
  },
  trackAndExpedite: {
    marginTop: 12,
    flexDirection: 'row',
    alignItems: 'center'
  },
  trackButton: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    height: 32,
    paddingHorizontal: 8,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: 'rgba(0, 0, 0, 0.26)'
  },
  trackButtonText: {
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.65)'
  },
  expediteButton: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    height: 32,
    marginLeft: 8,
    paddingHorizontal: 8,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: '#EE4D2D'
  },
  expediteButtonDisabled: {
    borderColor: 'rgba(0, 0, 0, 0.26)'
  },
  expediteButtonText: {
    fontSize: 14,
    color: '#EE4D2D'
  },
  expediteButtonTextDisabled: {
    color: 'rgba(0, 0, 0, 0.65)'
  },
  contactPanel: {
    marginTop: 14,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  contactInfo: {
    flex: 1
  },
  contactTitle: _objectSpread({
    fontSize: 14,
    lineHeight: 16,
    color: 'rgba(0, 0, 0, 0.87)'
  }, FONT_WEIGHT_MEDIUM),
  thContactTitle: {
    lineHeight: 20
  },
  openingHoursContainer: {
    marginTop: 4
  },
  thOpeningHoursContainer: {
    marginTop: 1
  },
  openingHours: {
    fontSize: 10,
    lineHeight: 12,
    color: 'rgba(0, 0, 0, 0.40)'
  },
  thOpeningHours: {
    lineHeight: 14
  },
  contactButtons: {
    marginLeft: 8,
    flexDirection: 'row',
    alignItems: 'center'
  },
  firstButtonContainer: {},
  firstButton: {
    flexGrow: 0,
    minWidth: undefined,
    borderTopWidth: 0,
    width: 44,
    height: 44,
    borderRadius: 26.4,
    backgroundColor: '#F5F5F5'
  },
  restButton: {
    marginLeft: 8,
    width: 44,
    height: 44,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 26.4,
    backgroundColor: '#F5F5F5'
  },
  linkPopup: {
    padding: 0
  },
  linkButton: {
    height: 40,
    textAlign: 'center',
    lineHeight: 32,
    padding: 0,
    margin: 0,
    paddingHorizontal: 12,
    marginLeft: 0,
    marginRight: 0
  },
  linkPopupGap: {
    backgroundColor: '#f5f5f5',
    height: 12
  },
  linkCancelButton: {
    height: 52,
    textAlign: 'center',
    fontSize: 16,
    lineHeight: 52,
    color: 'rgba(0, 0, 0, 0.87)',
    backgroundColor: '#ffffff'
  },
  contactPopup: {
    padding: 0
  },
  contactPopupTitle: {
    textAlign: 'center'
  },
  popupOpeningHoursContainer: {
    paddingHorizontal: 12,
    paddingTop: 12
  },
  popupOpeningHoursContent: {
    borderRadius: 4,
    overflow: 'hidden'
  },
  popupOpeningHours: {
    padding: 8,
    borderRadius: 8,
    fontSize: 12,
    lineHeight: 14,
    color: 'rgba(0, 0, 0, 0.54)',
    backgroundColor: '#f5f5f5'
  },
  thPopupOpeningHours: {
    lineHeight: 17
  },
  popupButton: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 48,
    borderTopWidth: 0,
    justifyContent: 'flex-start'
  },
  popupButtonText: {
    marginLeft: 8,
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.87)'
  },
  callOrEmailButton: {
    flexDirection: 'row',
    alignItems: 'center'
  }
});
export default Styles;